var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { useBackgroundContext } from '../BackgroundContext/index.js';
export const LINK_VARIANTS = [
    'inherit',
    'neutral',
    'primary',
    'accent',
];
export const Link = (_a) => {
    var { as, variant = 'accent', external, children, className, target, rel, disabled = false } = _a, rest = __rest(_a, ["as", "variant", "external", "children", "className", "target", "rel", "disabled"]);
    const Component = as || 'a';
    const { backgroundType } = useBackgroundContext();
    const linkTarget = external ? '_blank' : target;
    const linkRel = external ? 'noopener noreferrer' : rel;
    return (React.createElement(Component, Object.assign({ className: twMerge(clsx('cursor-pointer', 'transition duration-100 ease-in-out ', variant === 'inherit' && '', variant === 'neutral' && [
            backgroundType === 'main' &&
                'text-content-on-background-subdued hover:text-interactive-hovered',
            backgroundType === 'surface' &&
                'text-content-subdued hover:text-interactive-hovered',
            backgroundType === 'secondary' &&
                'text-content-on-topbar hover:text-interactive-hovered',
        ], variant === 'primary' &&
            'text-action-primary hover:text-action-primary', variant === 'accent' &&
            'text-interactive hover:text-interactive-hovered', className, disabled && 'pointer-events-none opacity-50')), target: linkTarget, rel: linkRel }, rest), children));
};
//# sourceMappingURL=Link.js.map